<template>
  <div class="ajuda">
    <div class="container">
      <h1 class="display-1 my-3">Ajuda</h1>
      <!-- <v-divider></v-divider>
      <p class="subtitle-2 grey--text my-3">
        Baixe este guia com informações passo-a-passo das principais
        funcionalidades do sistema. Para visualização dos manuais, se faz
        necessário que esteja instalado em seu computador o Adobe Reader. caso
        não possua instalado,
        <a href="https://get.adobe.com/br/reader/" target="_blank"
          >clique aqui</a
        >
        e siga as instruções de instalação.
      </p>
      <v-btn class="my-2" small outlined color="#006eb8">
        <v-icon>get_app</v-icon>
        <span>Baixar Manual</span>
      </v-btn> -->
      <v-divider></v-divider>
      <v-layout class="my-4">
        <v-flex xs12>
          <v-toolbar flat color="#006eb8" dark>
            <v-toolbar-title>Perguntas e Respostas</v-toolbar-title>
          </v-toolbar>
          <v-tabs color="#006eb8">
            <!-- <v-tab> <v-icon>info</v-icon>conceitos </v-tab> -->
            <!-- <v-tab> <v-icon left>how_to_reg</v-icon>Auto cadastro </v-tab>
            <v-tab> <v-icon left>dynamic_feed</v-icon>Emissão </v-tab>
            <v-tab> <v-icon left>description</v-icon>Guia recolhimento </v-tab>
            <v-tab> <v-icon left>card_giftcard</v-icon>Benefícios </v-tab>-->
            <v-tab> <v-icon left>flag</v-icon>Gerais </v-tab> 

            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-expansion-panels>
                    <v-expansion-panel
                      v-for="(pergunta, index) in gerais"
                      :key="index"
                    >
                      <v-expansion-panel-header>{{
                        pergunta.pergunta
                      }}</v-expansion-panel-header>
                      
                      <v-expansion-panel-content class="grey--text">
                        <div v-html="pergunta.resposta"></div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-expansion-panels>
                    <v-expansion-panel
                      v-for="(pergunta, index) in conceitos"
                      :key="index"
                    >
                      <v-expansion-panel-header>{{
                        pergunta.pergunta
                      }}</v-expansion-panel-header>
                      <v-expansion-panel-content class="grey--text">{{
                        pergunta.resposta
                      }}</v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-expansion-panels>
                    <v-expansion-panel
                      v-for="(pergunta, index) in credenciamento"
                      :key="index"
                    >
                      <v-expansion-panel-header>{{
                        pergunta.pergunta
                      }}</v-expansion-panel-header>
                      <v-expansion-panel-content class="grey--text">{{
                        pergunta.resposta
                      }}</v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-expansion-panels>
                    <v-expansion-panel
                      v-for="(pergunta, index) in emissao"
                      :key="index"
                    >
                      <v-expansion-panel-header>{{
                        pergunta.pergunta
                      }}</v-expansion-panel-header>
                      <v-expansion-panel-content class="grey--text">{{
                        pergunta.resposta
                      }}</v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-expansion-panels>
                    <v-expansion-panel
                      v-for="(pergunta, index) in guia"
                      :key="index"
                    >
                      <v-expansion-panel-header>{{
                        pergunta.pergunta
                      }}</v-expansion-panel-header>
                      <v-expansion-panel-content class="grey--text">{{
                        pergunta.resposta
                      }}</v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-expansion-panels>
                    <v-expansion-panel
                      v-for="(pergunta, index) in beneficios"
                      :key="index"
                    >
                      <v-expansion-panel-header>{{
                        pergunta.pergunta
                      }}</v-expansion-panel-header>
                      <v-expansion-panel-content class="grey--text">{{
                        pergunta.resposta
                      }}</v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-card>
            </v-tab-item>
            
          </v-tabs>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      conceitos: [
        {
          pergunta: "O que é o Domicílio Eletrônico - DT-e?",
          resposta:
            "O Domicílio Eletrônico é a Caixa Postal disponibilizada pelo município, onde são postadas e armazenadas as correspondências de caráter oficial dirigidas ao contribuinte.",
        },
        {
          pergunta: "O que muda com a instituição do DT-e?",
          resposta:
            "Na prática, o que mudou para o contribuinte com a adesão do Domicílio Eletrônico é que a ciência por parte do sujeito passivo de quaisquer tipos de atos administrativos, encaminhamento de notificações e intimações, expedição de avisos gerais, protocolo de documentos, dentre outros serviços passou a ser de forma eletrônica.",
        },
        {
          pergunta: "Como fica a Ciência dos Atos e Prazos Processuais?",
          resposta:
            "A ciência e a questão dos prazos processuais precisa ser tratada de forma separada devido aos fundamentos legais de cada esfera, seja municipal, estadual ou federal. O prazo para recurso permanece o mesmo, sendo considerada a partir da ciência da leitura da notificação.",
        },
      ],
      credenciamento: [
        {
          pergunta: "O que é o Auto Cadastro?",
          resposta:
            "É a autorização concedida pela Prefeitura de Goiânia aos prestadores de serviços não estabelecidos que possuam atividades com serviços e que eventualmente necessitam realizar prestação de serviços dentro do município de Goiânia.",
        },
        {
          pergunta: "Quando devo realizar solicitação do Auto Cadastro?",
          resposta:
            "O Auto Cadastro deve ser realizado uma única vez pelo prestador de serviços que deseja realizar a emissão de Nota Fiscal  no município e posteriormente caso haja uma nova prestação o credenciamento anterior permanece válido.",
        },
        {
          pergunta: "Quem deve solicitar o Auto Cadastro?",
          resposta:
            "Todos os prestadores dos serviços estabelecidos em outro município e profissionais autônomos que desejam realizar a emissão de Nota Fiscal .",
        },
        {
          pergunta: "Como efetuar o Auto Cadastro?",
          resposta:
            "O Auto Cadastro de prestadores de serviço estabelecidos em outro município que possuem atividades com serviço, devem efetuar o preenchimento do formulário. Ao preencher os dados relativos aos dados do prestador, endereço e suas atividades, será gerado uma inscrição de oficio de identificação deste prestador e um e-mail será encaminhado para o e-mail do prestador informado no auto cadastro para o cadastro de sua senha web para acesso a Nota Fiscal .",
        },
        {
          pergunta:
            "É possível um prestador já credenciado como NFSe realizar a emissão de uma nota fiscal ?",
          resposta:
            "Não. A emissão de nota fiscal  é restrita para as empresas ou profissionais autônomos não estabelecidos no município e eventualmente um profissional autônomo de dentro do município para fins comprobatórios da prestação de serviço.",
        },
        {
          pergunta:
            "É possível um prestador já credenciado como NFSe  realizar a emissão de uma nota fiscal eletrônica?",
          resposta:
            "Não. A emissão de nota fiscal eletrônica é restrita para empresas estabelecidas no município com atividades de prestação de serviço descritas no cronograma de ingresso.",
        },
      ],
      emissao: [
        {
          pergunta: "Como deve ser emitida a NFS-e ?",
          resposta:
            "A NFS-e  deve ser emitida apenas on-line no site do sistema NFSe , por meio da internet, somente pelos prestadores de serviços autorizados, mediante a utilização da Senha obtida no Auto Cadastro.A NFS-e  não poderá ser emitida por intermédio do envio de RPS pelo sistema off-line da prefeitura, por conta da geração instantânea de guia para recolhimento do imposto.",
        },
        {
          pergunta:
            "O que fazer em caso de eventual impedimento da emissão online da NFS-e ?",
          resposta:
            "No caso de eventual impedimento da emissão online da NFS-e , o prestador de serviços deverá procurar o setor de atendimento presencialmente para realizar a emissão da guia de recolhimento para posterior geração de nota fiscal .",
        },
        {
          pergunta: "Em quantas vias deve-se imprimir a NFS-e ?",
          resposta:
            "A NFS-e  deverá ser impressa por ocasião da prestação de serviços em via única. Sua impressão poderá ser dispensada na hipótese do tomador solicitar seu envio por 'e-mail'.",
        },
        {
          pergunta:
            "Pode-se enviar a NFS-e  por e-mail para o tomador de serviços?",
          resposta:
            "Sim. A NFS-e  poderá ser enviada por 'e-mail' ao tomador de serviços, desde que por sua solicitação. Nesse caso, o tomador pode dispensar a emissão da NFS-e . O prestador de serviços poderá, inclusive, adicionar comentários ao e-mail.",
        },
        {
          pergunta: " A NFS-e  terá numeração seqüencial específica?",
          resposta:
            "Sim. O número da NFS-e  será gerado pelo sistema, em ordem seqüencial, sendo único para cada estabelecimento da empresa prestadora de serviços e iniciado em 1.",
        },
        {
          pergunta:
            "Até quando é possível consultar a NFS-e , após sua emissão?",
          resposta:
            "As NFS-e  emitidas poderão ser sempre consultadas e impressas online no sistema NFS-e , independente do exercício escolhido.",
        },
        {
          pergunta: "É possível emitir NFS-e  com data retroativa?",
          resposta:
            "Não, a nota fiscal  é gerada mediante a comprovação do pagamento do imposto relativo à prestação de serviço.",
        },
      ],
      guia: [
        {
          pergunta:
            "Existe uma guia de recolhimento de ISS específica para a NFS-e ?",
          resposta:
            "Sim. O recolhimento do ISS, referente às NFS-e , deverá ser feito exclusivamente por meio de documento de arrecadação emitido pelo aplicativo da NFS-e  no endereço eletrônico acessando o link Emitir de Guia . Esta guia é disponibilizada após o preenchimento dos dados relativos à prestação de serviço, ou para pesquisa posterior.",
        },
        {
          pergunta:
            "Quando a guia de recolhimento de ISS fica disponível para emissão?",
          resposta:
            "A partir do preenchimento dos dados da prestação de serviço.",
        },
        {
          pergunta: "Qual é a data de vencimento do ISS referente às NFS-e ?",
          resposta:
            "O vencimento do imposto é sempre para o dia útil posterior ao preenchimento dos dados da prestação de serviço.",
        },
        {
          pergunta:
            "É possível re-emitir a guia de recolhimento após o vencimento do ISS?",
          resposta:
            "Sim. A guia estará disponível para re-impressão sem encargos até o último útil dia da competência seguinte a emissão, por exemplo, a nota fiscal emitida no dia 01/06/2019 tem até o dia 31/07/2019 para re-impressão. Vale ressaltar que até a confirmação de pagamento a nota não é disponibilizada no sistema, e o processo de re-impressão é uma facilidade para o contribuinte NFSe Avulso.",
        },
        {
          pergunta: "É possível cancelar guia de recolhimento emitida?",
          resposta:
            "Sim. Se a guia ainda não foi paga e se caso a empresa não desejar gerar a nota fiscal , esta poderá ser cancelada",
        },
      ],
      beneficios: [
        {
          pergunta: "Quais os benefícios para quem emite NFS-e ?",
          resposta:
            "1 - Redução de custos de impressão e de armazenagem de documentos fiscais (a NFSe –  é um documento emitido e armazenado eletronicamente em sistema próprio da Prefeitura de Goiânia), 2- Dispensa de comparecimento no Fisco para emissão da NFSe Avulso, pós credenciamento, 3- Emissão de NFSe –  por meio da internet, com preenchimento automático dos dados do tomador de serviços, desde que conste da base de dados do sistema,  4- Geração automática da guia de recolhimento por meio da internet,5- Possibilidade de envio de NFSevulsa por e-mail, 6- Maior eficiência no controle gerencial de emissão de NFSe , 7- Emissão do Talão Fiscal Eletrônico.",
        },
        {
          pergunta: "Quais os benefícios para quem recebe NFS-e ?",
          resposta:
            "1- Política de Incentivo do Município, 2- Possibilidade de recebimento de NFSe por e-mail, 3- Maior eficiência no controle gerencial de recebimento de NFSe, 4- Dispensa de lançamento das NFSe na Declaração Mensal de Serviços (DMS).",
        },
      ],
      gerais: [
        {
          pergunta: "Os programas NFSe e DES-IF são programas distintos ?",
          resposta:
            "Sim. <b>A DES-IF - Declaração Eletrônica de Serviços de Instituições Financeiras</b> refere-se à declaração dos serviços prestados pelas instituições financeiras e equiparadas e administradoras de consórcio. Para os serviços tomados de terceiros, pelas instituições financeiras e equiparadas, permanece a obrigatoriedade de importação dos arquivos declarando sua movimentação por meio do sistema NFSe. São aplicativos distintos relacionados às obrigações acessórias também distintas, a saber: <br> A <b>NFSe - Nota Fiscal de Serviços Eletrônica</b>, no caso das Instituições Financeiras, é destinada à escrituração e registro mensal de todos os serviços tomados ou vinculados aos responsáveis tributários previstos na legislação municipal, acobertados ou não por documentos fiscais e sujeitos à incidência do Imposto sobre Serviços de Qualquer Natureza - ISSQN, devido ou não ao Município. <br> <br><b>DES-IF</b>:<br>Declaração somente dos serviços prestados pelas administradoras de consórcios, instituições financeiras e equiparadas. A DES-IF é composta de 4 (quatro) módulos para envio dos arquivos: <br> <br> 1 - <b>Informações Comuns ao Município</b> (anual e quando houver alteração) <br> <br> <ul><li>Identificação da declaração</li> <li>Plano Geral de Contas Comentado (PGCC)</li><li>Tabela de tarifas da instituição</li><li>Tabela de identificação de serviços de remuneração variável</li></ul><br><br><b>2 - Apuração mensal do ISSQN (mensal)</b><br><br><ul><li>Identificação da Declaração;</li><li>Identificação de Dependência;</li><li>Demonstrativo da receita tributável e do ISSQN devido por subtítulo;</li><li>Demonstrativo do ISSQN mensal a recolher;</li></ul><br><br><b>3 - Demonstrativo Contábil (Anual)</b><br><br><ul><li>Identificação da declaração;</li><li>Identificação de dependência;</li><li>Balancete analítico mensal;</li><li>Demonstrativo de rateio de resultados internos;</li></ul><br><br><b>4 - Demonstrativo das partidas dos lançamentos contábeis (sob demanda)</b> <br><br> <ul><li>Demonstrativo das partidas dos lançamentos contábeis</li></ul>",
        },
        {
          pergunta:
            "As instituições financeiras continuam obrigadas a utilizar a NFSe - Nota Fiscal Eletrônica de Serviços ?",
          resposta:
            "Sim, a obrigação de utilizar a NFSe - Nota Fiscal Eletrônica de Serviços continua para os serviços tomados. A DES-IF refere-se a serviços prestados pelas instituições financeira e equiparadas e administradoras de consórcio.",
        },
        {
          pergunta:
            "O programa é apenas através de importação de arquivo, não existe digitação manual ?",
          resposta:
            "O aplicativo fornecido pela Prefeitura tem funcionalidades para validação, visualização, assinatura digital, envio da DES-IF e geração de guia. O programa não altera o arquivo “txt” gerado pela instituição e não possui nenhuma funcionalidade de digitação de dados referentes à declaração, portanto, toda movimentação deve ser declarada mediante importação de arquivos.",
        },
        {
          pergunta:
            "Se a instituição já possuir um certificado digital, poderá utilizá-lo para a DES-IF ?",
          resposta:
            "Sim. Caso a instituição já possua certificado digital, desde que pertença à cadeia ICP-Brasil, poderá utilizá-lo.",
        },
        {
          pergunta:
            "Quando a Instituição não possuir nenhuma movimentação de serviço que tenha sido tarifado no ISS, quais são os registros que obrigatoriamente necessitam ser gerados ?",
          resposta:
            "Quando não há movimento nos subtítulos referentes às receitas de prestação de serviços é necessário informar apenas os registros “0000“ e “0400“.",
        },
        {
          pergunta:
            "Onde é possível obter o layout ou endereço com as informações para a montagem dos arquivos para a DES-IF ?",
          resposta:
            "A documentação e tabelas de apoio para a DES-IF podem ser acessadas no link Manual, após realizar login no sistema.",
        },
        {
          pergunta:
            "O responsável pela declaração deve ser o representante legal (o presidente?) ou apenas uma pessoa para contato ?",
          resposta:
            "O responsável legal que foi solicitado refere-se ao CNPJ que responderá pelo envio e assinatura da DES-IF junto à Prefeitura. Não precisa ser referente à matriz ou à dependência estabelecida Município. Ele precisa ter certificação digital (pois terá de assinar ao transmitir a declaração) e também o poder para dar procuração a terceiros outorgando-lhes poderes relativos à DES-IF. Este responsável poderá delegar a responsabilidade de envio das declarações à outro, desde que vincule o novo responsável ao sistema. Para isso, deverá acessar o sistema com Certificado Digital da Instituição, selecionar o menu Sistema > Cadastro de Representante Legal da Instituição.",
        },
        {
          pergunta:
            "No envio das informações referente a DES-IF como será retornado o erro para regularização das diferenças ?",
          resposta:
            "O objetivo do aplicativo validador no cliente é que a declaração seja validada antes do processo de transmissão. Com isso ela sempre será enviada sem inconsistências. Os erros encontrados serão exibidos pelo próprio aplicativo. Sendo assim, a DES-IF será assinada e transmitida somente após a consistência com sucesso. Apenas os erros que não puderem ser verificados pelo validador, por exemplo com a relação ao número do CNPJ e Inscrição Municipal, é que serão consistidos e retornados no momento da transmissão. Os demais problemas, como falta de declaração de alguma dependência ou divergências com a auditoria, serão avaliados pela auditoria fiscal e disponibilizados através da Internet.",
        },
        {
          pergunta:
            "Como emitir a Guia de Recolhimento do ISSQN ?",
          resposta:
            "Após a importação do arquivo de Apuração Mensal, o responsável pela Instituição deve acessar o menu Declaração > Consulta, pesquisar o período correspondente da declaração e finalizá-la. Somente após finalizar a declaração a Guia será disponibilizada para recolhimento.",
        },
        {
          pergunta:
            "Ao acessar a opção para emissão da Guia, o valor do ISSQN está zerado. Por quê?",
          resposta:
            "O valor do ISSQN zerado ocorre quando no arquivo de Apuração Mensal o registro 0440 não possui valores no campo 21. Analise seu arquivo e realize as correções necessárias para que o ISSQN seja calculado conforme movimentação da Instituição.",
        },
        {
          pergunta:
            "Como abrir uma solicitação referente a ocorrências dos Sistemas NFSe Campinas ou DESIF?",
          resposta:
            "Acessar o link https://nfse.campinas.sp.gov.br/NotaFiscal/index.php e clicar no link “Fale Conosco- Requerimento”.",
        },
        {
          pergunta:
            "O Login via certificado digital não está funcionando no seu navegador web ?",
          resposta:
            "> Verifique se o certificado digital está instalado corretamente.<br><br>No Windows:<br>Pressione Win + R e digite certmgr.msc, depois pressione Enter.<br>Vá até Pessoal > Certificados e veja se seu certificado está listado.<br>Vá até Autoridades de Certificação Raiz Confiáveis > Certificados e veja se a Autoridade Certificadora Raiz do seu certificado digital está listada como confiável.<br><br>> Certifique-se de que o navegador está configurado corretamente.<br><br>Atualize o navegador para a versão mais recente.<br>Veja se o seu certificado aparece listado no navegadorGoogle Chrome/Edge:Acesse chrome://settings/security e veja se a opção Gerenciar Certificados lista o seu certificado.<br>Mozilla Firefox: Acesse about:preferences#privacy, role até a seção Segurança e clique em Certificados > Ver Certificados. Veja lista o seu certificado.<br><br>> Experimente abrir o sistema em janela/modo anônimo ou limpe o cache do seu navegador.<br><br>> Remova certificados digitais instalados vencidos para evitar conflitos.<br><br>> Teste em outro navegador (testes realizados em Google Chrome, Mozilla Firefox, Microsoft Edge)<br><br>> Verifique o driver e o hardware, se estiver usando um token USB ou smartcard.<br><br>No Windows:<br>Abra o Gerenciador de Dispositivos (devmgmt.msc) e veja se há algum erro no driver do leitor de cartão/token.<br>Atualize os drivers do leitor/token.<br>Reinstale o software da Autoridade Certificadora que emitiu seu certificado.<br><br>> Remova e reinstale o certificado digital",
        },
        {
          pergunta:
            "O aplicativo de entrega da DES-IF não está abrindo e exibe a mensagem de erro: “Aplicativo Bloqueado pela Segurança do Java”. Por quê?",
          resposta:
          "<b>Causa:</b><br><br>O aplicativo é assinado digitalmente com um certificado Code Signing emitido pela Autoridade Certificadora GlobalSign. No entanto, o Gerenciador de Certificados do Windows não está reconhecendo esse certificado raiz como válido.<br><br><b>Solução:</b><br><br>Baixe o certificado raiz “GlobalSign Code Signing Root R45” no site da GlobalSign, acessando o link:<br>https://secure.globalsign.com/cacert/codesigningrootr45.crt.<br><br>Após o download, dê um duplo clique no arquivo e siga as instruções para instalar o certificado no seu computador.<br><br>Com a instalação concluída, tente novamente executar o aplicativo da DES-IF no sistema web de Campinas",
        },
        {
          pergunta:
            "Como é feito o cadastro da Instituição Financeira no Sistema DES-IF?",
          resposta:
            "O cadastro da Instituição Financeira no Sistema DES-IF é feito de forma automática a partir da abertura de sua inscrição no Cadastro Municipal de Receitas Mobiliárias. Com isso, o reconhecimento do certificado digital da Instituição Financeira também é feito de forma automática",
        },
      ],
    };
  },
};
</script>
